import Model from './Model'

export default class Currency extends Model {
  resource () { return 'currencies' }
}
